import { render, staticRenderFns } from "./CenterInfo.vue?vue&type=template&id=7ccfa41e&scoped=true"
import script from "./CenterInfo.vue?vue&type=script&lang=js"
export * from "./CenterInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ccfa41e",
  null
  
)

export default component.exports